const { OPERATION, CATEGORY, CODE, OPERATIONS, CATEGORIES, CODES, requireMember, validHttpStatus, optionalRequestId } = require('./contract');

class OperationError extends Error {
    constructor({ operation, category, code, status, requestId, cause }) {
        requireMember(operation, OPERATIONS, 'operation');
        requireMember(category, CATEGORIES, 'category');
        requireMember(code, CODES, 'code');
        super(`${operation}: ${code}`);
        this.name = 'OperationError';
        this.operation = operation;
        this.category = category;
        this.code = code;
        if (validHttpStatus(status) !== undefined) this.status = status;
        if (optionalRequestId(requestId)) this.requestId = requestId;
        if (cause instanceof Error) Object.defineProperty(this, 'cause', { value: cause });
    }
}

function normalizeAxiosError(error, operation = OPERATION.API_OTHER) {
    if (!(error instanceof Error)) {
        return new OperationError({ operation, category: CATEGORY.UNEXPECTED, code: CODE.UNEXPECTED_ERROR });
    }
    if (error instanceof OperationError) return error;
    const status = validHttpStatus(error.response?.status);
    const backendCode = error.response?.data?.code;
    const code = CODES.has(backendCode) && backendCode !== CODE.UNKNOWN_API_ERROR
        ? backendCode
        : status !== undefined ? CODE.UNKNOWN_API_ERROR
            : error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT' ? CODE.REQUEST_TIMEOUT : CODE.NETWORK_ERROR;
    const category = status !== undefined ? CATEGORY.HTTP : code === CODE.REQUEST_TIMEOUT ? CATEGORY.TIMEOUT : CATEGORY.NETWORK;
    return new OperationError({
        operation, category, code, status,
        requestId: error.response?.headers?.['x-request-id'], cause: error,
    });
}

function normalizeJqueryError(response, textStatus, operation) {
    requireMember(operation, OPERATIONS, 'operation');
    const status = validHttpStatus(response?.status);
    const backendCode = response?.responseJSON?.code;
    const code = CODES.has(backendCode) && backendCode !== CODE.UNKNOWN_API_ERROR
        ? backendCode : status !== undefined ? CODE.UNKNOWN_API_ERROR
            : textStatus === 'timeout' ? CODE.REQUEST_TIMEOUT : CODE.NETWORK_ERROR;
    return new OperationError({
        operation,
        category: status !== undefined ? CATEGORY.HTTP : textStatus === 'timeout' ? CATEGORY.TIMEOUT : CATEGORY.NETWORK,
        code,
        status,
        requestId: typeof response?.getResponseHeader === 'function'
            ? response.getResponseHeader('X-Request-ID') : undefined,
    });
}

module.exports = { OperationError, normalizeAxiosError, normalizeJqueryError };
